import Vue from 'vue'
import { mapState } from 'vuex'
import rolebleMixin from '@/mixins/rolebleMixin'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [rolebleMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
      userId: (state: RootState) => state.user?.id,
    }),
    isEmployer() {
      return this.isCustomer && this.application?.customer.id === this.userId
    },
    isWorker() {
      return this.isFreelancer && this.application.freelancer.id === this.userId
    },
  },
})
